import React from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';
import { useQuery } from 'react-query';
import { getAllData } from 'apis/customApiHandler';

const Add = ({ data, handleClick }) => {
  const { data: allMakes } = useQuery(['vehicle-make-master'], () =>
    getAllData('/vehicle-make-master', {
      limit: 100,
      page: 1,
    })
  );
  const initialValues = {
    make:
      (data?.make?._id && {
        value: data?.make?._id,
        label: data?.make?.make,
      }) ||
      '',
    name: data?.name || '',
  };

  const inputFields = [
    {
      name: 'make',
      label: 'Select Vehicle Make',
      type: 'select',
      options: allMakes?.data?.map((make) => ({
        value: make._id,
        label: make.make,
      })),
    },
    {
      name: 'name',
      label: 'Vehicle Model Name',
      type: 'text',
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={data ? 'Update Vehicle Model' : 'Add Vehicle Model'}
      url={'vehicle-model-master'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="vehicle-model-master"
      inputFields={inputFields}
      data={initialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
